/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_TitleInputs */

const en_terms_title = /** @type {(inputs: Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const id_terms_title = /** @type {(inputs: Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketentuan Layanan`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_title = /** @type {((inputs?: Terms_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_title(inputs)
	return en_terms_title(inputs)
});